/* eslint-disable quote-props, consistent-return */

import i18next from 'i18next';
import moment from 'moment';
import ChainedBackend from 'i18next-chained-backend';
import BrowserLanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
// import LocalStorageBackend from 'i18next-localstorage-backend';
import { initReactI18next } from 'react-i18next';
// import resourcesToBackend from 'i18next-resources-to-backend';
import { Langs } from '../../../shared/helpers';
import toast from './toast';

const Namespace = {
  COMMON: 'common',
  MANAGE_PROJECT: 'manage-project',
  PHOTO_UPLOADER: 'photo-uploader',
  OUTLINE: 'outline',
  DRAFT: 'draft',
  WRITER_MATCH: 'writer-match',
  QUESTIONNAIRE: 'questionnaire',
  PROOF: 'proof',
  ALL_PROJECTS: 'all-projects',
  ALL_ACCOUNTS: 'all-accounts',
  PROJECT_OVERVIEW: 'project-overview',
  UPGRADES: 'upgrades',
  COVER_CREATOR: 'cover-creator',
  ACCOUNT_PAGE: 'account-page',
  LANGUAGES: 'languages',
  INTERVIEWS: 'interviews',
  TIMELINE: 'timeline',
  PROJECTS_FEEDBACK: 'projects-feedback',
  ONBOARDING_FEEDBACK: 'onboarding-feedback',
  PROOF_FEEDBACK: 'proof-feedback',
  UPGRADES_TABLE: 'upgrades-table',
  STYLE_SAMPLES: 'style-samples',
  BOOK_SAMPLE: 'book-sample',
  PROMPT_LIBRARY: 'prompt-library',
  WRITER_FEEDBACK_TABLE: 'writer-feedback-table',
  ALL_UPGRADES: 'all-upgrades',
  BOOK_SPECIFICATION: 'book-specification',
  VERSIONS: 'versions',
};

i18next
  .use(ChainedBackend)
  // TODO: lazy loading translations using webpack
  /* .use(resourcesToBackend((language, namespace, callback) => {
    import(`../../../../client/public/locales/${language}/${namespace}.json`)
      .then((resources) => {
        callback(null, resources)
      })
      .catch((error) => {
        callback(error, null)
      })
  })) */
  .use(BrowserLanguageDetector)
  .use(initReactI18next)
  .init(
    {
      initImmediate: true,
      supportedLngs: [Langs.CodePrimary.EN_GB, Langs.CodePrimary.NL_NL],
      fallbackLng: {
        [Langs.CodePrimary.NL_NL]: [Langs.CodePrimary.NL_NL],
        'default': [Langs.CodePrimary.EN_GB],
      },
      ns: [
        Namespace.COMMON,
        Namespace.LANGUAGES,
      ],
      defaultNS: Namespace.COMMON,
      nsSeparator: ':',
      keySeparator: '.',
      pluralSeparator: '_',
      contextSeparator: '_',
      returnNull: false,
      returnEmptyString: false,
      interpolation: {
        escapeValue: false,
        prefix: '{{',
        suffix: '}}',
      },
      detection: {
        order: [
          'localStorage',
          'sessionStorage',
          'cookie',
          'navigator',
          'querystring',
          'htmlTag',
          'path',
          'subdomain',
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,
      },
      react: {
        useSuspense: false, // TODO: temprorarily disabled, make adjustments if necessary
      },
      backend: {
        backends: [
          // TODO: browser caching with local storage
          // LocalStorageBackend,
          HttpBackend,
          // TODO: Backend fallback
          /* resourcesToBackend((lng, ns, clb) => {
            import(`../../../../client/public/locales/${lng}/${ns}.json`)
                  .then((resources) => clb(null, resources))
                  .catch(clb)
          }) */
        ],
        backendOptions: [
          /* {
            prefix: 'i18next_res_',
            expirationTime: 7 * 24 * 60 * 60 * 1000,
          }, */
          {
            allowMultiLoading: false,
            loadPath: '/locales/{{lng}}/{{ns}}.json',
            requestOptions: {
              method: 'GET',
              mode: 'cors',
              cache: 'default', // default, no-store, reload, no-cache, force-cache, only-if-cached
              credentials: 'same-origin',
            },
          },
        ],
      },
    },
    (err) => {
      if (err) return console.error(err);
      console.log('i18next: initialized');
    },
  );

function decorate(instance) {
  instance.setCurrentLanguage = async function (language) {
    try {
      await instance.changeLanguage(language);
      moment.locale(language);
    } catch (error) {
      console.error(`Error changing the language: ${error}`);
      toast.error('There was an error when changing the language');
    }
  };

  instance.getCurrentLanguage = function () {
    return instance.resolvedLanguage;
  };

  instance.Namespace = Namespace;

  return instance;
}

export default decorate(i18next);
